import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { memo, useMemo } from 'react';
import strings from '../../Globalization/index';
import { useCycleInfo } from '../../contexts/CycleInfo/Context';
import util from '../../util';
import connectionService from '../../services/Connection';
import { evalTopSection } from './dataUtil';


const TopSection = () => {
	const { data } = useCycleInfo();
	const theme = useTheme();
	const spacing = theme.spacing(12);
	const screen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
	const dateTimeFormat = util.getDateTimeFormat();
	const gridColumnTemplate = screen ? '1fr 1em 1fr 1fr 1em 1fr' : '1fr 1em 1fr 1fr 1em 1fr 1fr 1em 1fr'
	const entries = useMemo(() => evalTopSection({
		data,
		dateTimeFormat,
	}), [data, dateTimeFormat]);

	return (
		<Grid container>
			<Box sx={{ flexGrow: 1 }}>
				<Grid container>
					<Grid size={{ xs: 12, lg: 2 }}>
						<Box sx={{ flexGrow: 1, textAlign: 'center' }}>
							<Grid container spacing={1}>
								<Grid size={12}>
									<Box
										component="img"
										src={`${connectionService.PTXImage}/${data.CycleImageUrl}?v=${new Date()}`}
										alt={data.EquipmentName}
										sx={{ height: spacing, width: 'auto' }}
										height={spacing}
										width={'auto'}
									/>
								</Grid>

								<Grid size={12}>
									{!!data?.EquipmentName && (
										<Typography
											className="cycle-serialNumber"
											variant="h5"
											fontWeight={'bold'}
											title={strings.EquipmentName}
											component="span"
										>
											{data.EquipmentName}
										</Typography>
									)}
								</Grid>
								<Grid size={12}>
									{!!data?.ModelName && (
										<Typography
											variant="subtitle1"
											fontWeight={'bold'}
											title={strings.ModalName}
											component="span"
										>
											{data.ModelName}
										</Typography>
									)}
								</Grid>
								<Grid size={12}>
									{!!data?.SerialNumber && (
										<Typography
											className="cycle-serialNumber"
											variant="subtitle2"
											fontWeight={'bold'}
											title={strings.SerialNumber}
											component="span"
										>
											{data.SerialNumber === '-1' ? '' : data.SerialNumber}
										</Typography>
									)}
								</Grid>
							</Grid>
						</Box>
					</Grid>
					<Grid size={{xs: 12, lg: 10}} container>
						{entries?.length && (
							<Grid
								size={12}
								sx={{
									fontSize: 12,
									display: 'grid',
									gridTemplateColumns: gridColumnTemplate,
									gap: '3px 5px',
									'& .LabelBold': {
										fontWeight: 'bold'
									}
								}}
							>
								{entries.reduce(
									(acc, { HeaderLabel, Name, value, renderValue, element }, index) =>
										acc.concat([
											<Typography
												component='span'
												className="LabelBold"
												fontSize='inherit'
												key={`label-${index}`}
											>
												{strings[HeaderLabel] || strings[Name] || HeaderLabel}
											</Typography>,
											<Typography
												variant="body2"
												component='span'
												fontSize='inherit'
												className="LabelBold"
												key={`colon-${index}`}
											>
												:
											</Typography>,
											renderValue ? (
												renderValue({ data, value })
											) : (
													<Typography
														component='span'
														fontSize='inherit'
														key={`value-${index}`}
													>
														{element ? element : value}
													</Typography>
												)
										]),
									[]
								)}
							</Grid>
						)}
					</Grid>
				</Grid>
			</Box>
		</Grid>
	);
};
export default memo(TopSection);